'use client';

import { useCallback, useEffect, useState } from 'react';
import { useSwiper } from 'swiper/react';

export interface IWithSwiperButtonProps {
  children({
    slidePrev,
    slideNext,
    isBeginning,
    isEnd
  }: {
    slidePrev(): void;
    slideNext(): void;
    isBeginning: boolean;
    isEnd: boolean;
  }): React.ReactNode;
}

export default function WithSwiperButton({ children }: IWithSwiperButtonProps) {
  const swiper = useSwiper();
  const [isBeginning, setIsBeginning] = useState(false);
  const [isEnd, setIsEnd] = useState(false);

  const slidePrev = useCallback(() => {
    swiper.slidePrev();
  }, [swiper]);

  const slideNext = useCallback(() => {
    swiper.slideNext();
  }, [swiper]);

  useEffect(() => {
    swiper.on('slideChange', () => {
      setIsBeginning(swiper.isBeginning);
      setIsEnd(swiper.isEnd);
    });
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  }, [swiper]);

  return children({ slidePrev, slideNext, isBeginning, isEnd });
}
